import { useQuery } from "@tanstack/react-query";
import { useRouterState } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export type PageOverride = {
  id: string;
  path: string;
  label: string | null;
  category: string | null;
  seo_title: string | null;
  seo_description: string | null;
  hero_eyebrow: string | null;
  hero_title: string | null;
  hero_sub: string | null;
  cover_url: string | null;
  enabled: boolean;
};

function normalize(p: string) {
  if (!p) return "/";
  const noQuery = p.split("?")[0].split("#")[0];
  if (noQuery.length > 1 && noQuery.endsWith("/")) return noQuery.slice(0, -1);
  return noQuery;
}

export function usePageOverrideByPath(path: string | undefined) {
  const key = path ? normalize(path) : null;
  return useQuery({
    queryKey: ["page_override", key],
    enabled: !!key,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("page_overrides")
        .select("*")
        .eq("path", key!)
        .eq("enabled", true)
        .maybeSingle();
      if (error) throw error;
      return (data as PageOverride | null) ?? null;
    },
    staleTime: 60_000,
  });
}

export function useCurrentPageOverride() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return usePageOverrideByPath(path);
}
